import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipArrowComponent, TooltipComponent } from './tooltip.component';
import { TooltipDirective } from './tooltip.directive';
import { SafePipeModule } from 'safe-pipe';

@NgModule({
  declarations: [TooltipComponent, TooltipArrowComponent, TooltipDirective],
  imports: [CommonModule, SafePipeModule],
  exports: [TooltipDirective],
})
export class TooltipModule {}
